import {
    CheckOutlined,
    ExclamationCircleOutlined,
    FormOutlined,
    SyncOutlined,
    WarningOutlined,
    RetweetOutlined,
} from '@ant-design/icons'

import getColor from '~/lib/getColor'
import {
    DFM_APPROVAL_REQUIRED,
    DFM_APPROVED,
    DFM_NEEDS_FICTIV_REVIEW,
    DFM_PENDING_REVISION,
    DFM_REVISION_REQUIRED,
    DFM_STATE_COLORS,
    DFM_WARNING_ACCEPTED,
    DFM_WARNING,
    ImDfmStateType,
} from '../constants'

const getIconStyle = (status: ImDfmStateType) => ({
    color: DFM_STATE_COLORS[status] && getColor(DFM_STATE_COLORS[status]),
    fontSize: '16px',
    margin: '2px 8px 0 0',
})

type StatusOverviewPropsType = {
    status?: ImDfmStateType
}

const StatusOverviewIcon = (props: StatusOverviewPropsType) => {
    const { status } = props

    if (!status) {
        return null
    }

    const iconStyle = getIconStyle(status)

    switch (status) {
        case DFM_APPROVAL_REQUIRED:
            return <FormOutlined style={iconStyle} />
        case DFM_APPROVED:
            return <CheckOutlined style={iconStyle} />
        case DFM_NEEDS_FICTIV_REVIEW:
            return <RetweetOutlined style={iconStyle} />
        case DFM_PENDING_REVISION:
            return <SyncOutlined style={iconStyle} />
        case DFM_REVISION_REQUIRED:
            return <ExclamationCircleOutlined style={iconStyle} />
        case DFM_WARNING:
            return <WarningOutlined style={iconStyle} />
        case DFM_WARNING_ACCEPTED:
            return <CheckOutlined style={iconStyle} />
        default:
            return null
    }
}

export default StatusOverviewIcon
